package pl.michal_cyran.brand_hub.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import pl.michal_cyran.brand_hub.components.layouts.PageLayoutData
import pl.michal_cyran.brand_hub.pages.utils.PageContent
import pl.michal_cyran.brand_hub.subpages.freelancing.FreelancingFinalCTA
import pl.michal_cyran.brand_hub.subpages.freelancing.FreelancingHero
import pl.michal_cyran.brand_hub.subpages.freelancing.FreelancingKMP
import pl.michal_cyran.brand_hub.subpages.freelancing.FreelancingStack


@InitRoute
fun initFreelancingPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Freelance"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun FreelancingPage() {
    Column(
        modifier = Modifier
            .fillMaxSize()
    ) {
        PageContent(
            { FreelancingHero() },
            { FreelancingKMP() },
            { FreelancingStack() },
            { FreelancingFinalCTA() },
        )
    }
}
